import { Controller } from "@hotwired/stimulus"

// Opens text in a full-screen reading view (a native modal dialog), with a
// close button in the top-right corner. Escape closes it too.
// Connects to data-controller="reader"
export default class extends Controller {
  static targets = ["dialog"]

  connect() {
    this.onClose = () => document.documentElement.classList.remove("reader-open")
    this.dialogTarget.addEventListener("close", this.onClose)
  }

  disconnect() {
    this.dialogTarget.removeEventListener("close", this.onClose)
    document.documentElement.classList.remove("reader-open")
  }

  open() {
    if (this.dialogTarget.open) return

    document.documentElement.classList.add("reader-open")
    this.dialogTarget.showModal()
  }

  close() {
    this.dialogTarget.close()
  }
}
